<template>
  <div
    class="contents"
    :class="{ reverse: reverse, 'js-color-change': $store.state.isMobile }"
    data-logo-color="color"
    data-scroll-section
  >
    <div class="contents__col photo" :class="{ reverse: reverse }">
      <div class="contents__photo">
        <div class="contents__photo-in">
          <img
            data-scroll
            :data-scroll-speed="$store.state.isMobile ? 1 : 0.7"
            data-scroll-delay="0.1"
            :src="photoSrc"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="contents__col text">
      <div class="contents__lead">
        <h4 class="lead" ref="lead">
          <slot name="lead"></slot>
          <img class="quote left" src="@/assets/quote-left.png" alt="" />
          <img class="quote right" src="@/assets/quote-right.png" alt="" />
        </h4>
      </div>
      <div class="contents__body">
        <div class="contents__body__in" :class="{ reverse: reverse }">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'lazysizes'

export default {
  props: {
    direction: {
      type: String,
      default: 'right',
      require: true
    },
    photoSrc: {
      type: String,
      require: true
    }
  },

  data() {
    return {
      inView: false
    }
  },

  computed: {
    reverse() {
      if (this.$store.state.isMobile) return false
      return this.direction === 'left' ? true : false
    }
  }
}
</script>

<style lang="scss" scoped>
.contents {
  position: relative;
  display: flex;
  padding: 0 0 6rem;
  @media screen and (max-width: $breakpoint-mobile) {
    flex-direction: column;
  }

  &.reverse {
    flex-direction: row-reverse;
  }
  &__col {
    &.photo {
      flex: 0.8;
      width: 200rem;
      transform: translate(4rem, 20rem);
      z-index: 9;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 100%;
        transform: translate(0, 0);
      }

      &.reverse {
        transform: translate(-4rem, 20rem);
      }
    }

    &.text {
      flex: 1.2;
    }
  }

  &__photo {
    transform: skewY(-6deg) translate(0, 0);
    overflow: hidden;
    height: calc(57rem - 20rem);
    position: relative;
    z-index: 9;
    @media screen and (max-width: $breakpoint-mobile) {
      height: calc(36rem - 10rem);
    }
  }

  &__photo-in {
    position: absolute;
    width: 100%;
    height: 57rem;
    transform: translate3d(0, -10rem, 0) skewY(6deg);
    @media screen and (max-width: $breakpoint-mobile) {
      transform: translate3d(0, -5rem, 0) skewY(6deg);
      height: 36rem;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      backface-visibility: hidden;
      will-change: transform;
    }
  }

  &__lead {
    width: 85rem;
    margin: 0 auto;
    transform: skewY(-6deg);
    text-align: left;
    color: #fff;
    font-size: 5rem;
    font-weight: 800;
    line-height: 1.3;
    padding: 10rem 6rem;
    @media screen and (max-width: $breakpoint-mobile) {
      display: flex;
      align-items: center;
      width: 100%;
      font-size: 2.6rem;
      padding: 6rem 1.2rem;
    }

    .lead {
      position: relative;
      @media screen and (max-width: $breakpoint-mobile) {
        margin: 0 auto;
      }
      ::v-deep .word {
        white-space: nowrap;
        overflow: hidden;
      }

      ::v-deep .char {
        transform: translate3d(0%, 100%, 0);
      }
    }

    .quote {
      position: absolute;

      $delay: 0.3s;

      &.left {
        top: -10rem;
        left: -12rem;
        transform: translate3d(50%, 50%, 0);
        opacity: 0.3;
        transform: translate3d(0, 0, 0);

        @media screen and (max-width: $breakpoint-mobile) {
          top: -10rem;
          left: -5rem;
          width: 12rem;
        }
      }
      &.right {
        bottom: -8rem;
        right: 0rem;
        transform: translate3d(-50%, -50%, 0);
        opacity: 0.3;
        transform: translate3d(0, 0, 0);

        @media screen and (max-width: $breakpoint-mobile) {
          bottom: -8rem;
          right: -4rem;
          width: 12rem;
        }
      }
    }
  }

  &__body {
    background: #fff;
    padding: 10rem;
    transform: skewY(-6deg);
    @media screen and (max-width: $breakpoint-mobile) {
      padding: 6rem 2rem;
    }

    &__in {
      transform: skewY(6deg);
      font-size: 1.8rem;
      text-align: justify;
      font-weight: 500;
      letter-spacing: 0.6px;
      width: 75rem;
      max-width: 600px;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 100%;
        font-size: 1.4rem;
        letter-spacing: 0.2px;
      }

      &.reverse {
        margin: 0 0 0 auto;
      }
      p {
        margin: 0 0 3.5rem;
        line-height: 1.65;
        font-weight: 600;

        &.interviewer {
          font-size: 1.8rem;
          color: var(--main-color);
          font-weight: 800;
          line-height: 1.55;
          @media screen and (max-width: $breakpoint-mobile) {
            font-size: 1.6rem;
          }
        }

        .name {
          font-weight: 700;
          padding: 0 3rem 0 0;
          color: var(--main-color);

          &.secondary {
            color: blue;
          }
        }
      }

      img {
        width: 100%;
      }
    }
  }

  .tri {
    position: absolute;
    left: -24rem;
    bottom: -60rem;
    width: 100rem;
    z-index: -9;

    &.reverse {
      right: -20rem;
      left: inherit;
      bottom: 10rem;
      transform: rotate(180deg);
    }
  }
}
</style>
